import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { CurrencyProvider } from "@/i18n/CurrencyContext";
import Home from "@/pages/Home";
import InstantLanding from "@/pages/InstantLanding";
import EventBooking from "@/pages/EventBooking";
import BookingAck from "@/pages/BookingAck";
import Admin from "@/pages/Admin";
import { initAnalytics, trackPageView } from "@/lib/analytics";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <LanguageProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/instant" element={<InstantLanding />} />
            <Route path="/event-booking" element={<EventBooking />} />
            <Route path="/booking/:bookingId" element={<BookingAck />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;
